import { defineStyleConfig } from '@chakra-ui/react';

const Table = defineStyleConfig({
  baseStyle: (props) => ({
    table: {
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    th: {
      fontWeight: '600',
      fontSize: 'sm',
      textTransform: 'none',
      letterSpacing: 'normal',
      color: props.colorMode === 'dark' ? 'text.primary' : 'ink.secondary',
      borderColor: props.colorMode === 'dark' ? 'gray.700' : 'line',
      borderBottomWidth: '1px',
      bg: props.colorMode === 'dark' ? 'surface.darkContent' : 'surface.content',
      py: '14px',
      px: '16px',
    },
    td: {
      fontSize: 'sm',
      borderColor: props.colorMode === 'dark' ? 'gray.700' : 'line',
      py: '14px',
      px: '16px',
      color: props.colorMode === 'dark' ? 'text.primary' : 'ink.primary',
    },
  }),
  variants: {
    simple: (props) => ({
      tbody: {
        tr: {
          '&:hover': {
            bg: props.colorMode === 'dark' ? 'gray.700' : '#F7FAFC',
          },
          borderBottomWidth: '1px',
          borderBottomColor: props.colorMode === 'dark' ? 'gray.700' : 'line',
        }
      },
    }),
    striped: (props) => ({
      tbody: {
        tr: {
          '&:nth-of-type(odd)': {
            bg: props.colorMode === 'dark' ? 'gray.850' : '#FAFBFC',
          },
          '&:hover': {
            bg: props.colorMode === 'dark' ? 'gray.700' : '#EDF2F7',
          }
        }
      },
    })
  },
  defaultProps: {
    variant: 'simple',
  },
});

export default Table;
